import { PERMISSIONS } from '@/constants/permissions';
import { BASE } from './routes';

export interface NavItem {
  to: string;
  label: string;
  /**
   * Permission(s) required to see this nav item and access its route.
   * An array means any-of — the item shows when the user holds at least one.
   */
  permission: string | string[];
}

export const NAVIGATION: NavItem[] = [
  // Dashboard temporarily disabled — { to: BASE, label: 'Dashboard', permission: PERMISSIONS.DASHBOARD_VIEW },
  { to: `${BASE}/items`, label: 'Artikel', permission: PERMISSIONS.ITEMS_VIEW },
  {
    to: `${BASE}/business-partners`,
    label: 'Geschäftspartner',
    permission: PERMISSIONS.BUSINESS_PARTNERS_VIEW,
  },
  {
    to: `${BASE}/preis-tool`,
    label: 'Preis-Tool',
    permission: PERMISSIONS.PREIS_TOOL_VIEW,
  },
  {
    to: `${BASE}/calculator`,
    label: 'Rechner',
    permission: PERMISSIONS.PREIS_TOOL_VIEW,
  },
  {
    to: `${BASE}/email-builder`,
    label: 'E-Mail-Builder',
    permission: PERMISSIONS.EMAIL_BUILDER_VIEW,
  },
  {
    to: `${BASE}/sourcing`,
    label: 'Ausschreibungen',
    permission: PERMISSIONS.SOURCING_VIEW,
  },
  {
    to: `${BASE}/admin`,
    label: 'Admin',
    // The Admin section hosts several secondary-nav tabs, each with its own
    // permission (sync → ADMIN_VIEW, Lieferantenpreislisten →
    // SUPPLIER_PRICE_LISTS_VIEW, Spezifikationen → SPECIFICATIONS_VIEW,
    // Benutzer → USERS_MANAGE, Rollen → ROLES_MANAGE). Show the Admin nav for
    // anyone who can reach at least one tab; AdminPage redirects to the first
    // tab the user is allowed to open.
    permission: [
      PERMISSIONS.ADMIN_VIEW,
      PERMISSIONS.SUPPLIER_PRICE_LISTS_VIEW,
      PERMISSIONS.SPECIFICATIONS_VIEW,
      PERMISSIONS.USERS_MANAGE,
      PERMISSIONS.ROLES_MANAGE,
    ],
  },
];
